import { PaymentFrequency } from '../../Models/Payment/DirectDebit';
import { ExpiryDate } from './PaymentDetails';

interface IbanPaymentDetails {
  kind: 'bankaccount';
  accountHolderName: string;
  iban: string;
  dateToDonateInMonth: string;
  startDonationFrom: ExpiryDate;
  paymentFrequency: PaymentFrequency;
}

const DefaultIbanBankAccountDetails: IbanPaymentDetails = {
  kind: 'bankaccount',
  accountHolderName: '',
  iban: '',
  dateToDonateInMonth: '',
  startDonationFrom: { month: '', year: '' },
  paymentFrequency: PaymentFrequency.Monthly
};

export { IbanPaymentDetails, DefaultIbanBankAccountDetails };


// WEBPACK FOOTER //
// ./src/Types/Payments/IbanPaymentDetails.ts